import React from 'react';
import { ExternalLink, Trash2, Pencil, Lock, Users, CheckCircle2, Circle } from 'lucide-react';

export const CalendarItemRow = ({ it, cfg, onOpen, onEdit, onDelete, onToggleDone, testId }) => {
  const Icon = cfg.icon;
  const isTask = it.kind === 'task';
  const DoneIcon = it.completada ? CheckCircle2 : Circle;
  const timeLabel = it.time ? (it.end_time ? `${it.time}–${it.end_time}` : it.time) : (it.all_day && !isTask ? 'Todo el día' : '');
  return (
    <div
      className={`group flex items-center gap-3 p-2.5 rounded-lg bg-muted/30 ${onOpen ? 'hover:bg-muted/60 cursor-pointer' : ''}`}
      onClick={() => onOpen?.(it)}
      data-testid={testId}
    >
      <div className={`w-1 h-9 rounded-full ${cfg.dot}`} />
      {isTask && onToggleDone ? (
        <button onClick={(e) => { e.stopPropagation(); onToggleDone(it); }} className={`shrink-0 ${cfg.text}`} title={it.completada ? 'Marcar pendiente' : 'Marcar hecha'} data-testid={`toggle-done-${it.id}`}>
          <DoneIcon className="w-4 h-4" />
        </button>
      ) : (
        <Icon className={`w-4 h-4 shrink-0 ${cfg.text}`} />
      )}
      <div className="flex-1 min-w-0">
        <p className={`text-sm font-medium truncate flex items-center gap-1 ${it.completada ? 'line-through text-muted-foreground' : ''}`}>
          {it.title}
          {it.privado && <Lock className="w-3 h-3 text-muted-foreground" title="Privado" />}
          {(it.invitar_todos || (it.invitados && it.invitados.length > 0)) && <Users className="w-3 h-3 text-blue-500" title="Compartido con el equipo" />}
        </p>
        <p className="text-xs text-muted-foreground truncate">{[cfg.label, it.subtitle].filter(Boolean).join(' · ')}</p>
      </div>
      {it.meet_link && (
        <a href={it.meet_link} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="text-blue-600 hover:text-blue-700 shrink-0" title="Abrir Meet" data-testid={`meet-link-${it.id}`}>
          <ExternalLink className="w-4 h-4" />
        </a>
      )}
      {timeLabel && <span className="text-xs font-medium text-muted-foreground shrink-0">{timeLabel}</span>}
      {onEdit && (
        <button onClick={(e) => { e.stopPropagation(); onEdit(it); }} className="opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-primary shrink-0" data-testid={`edit-item-${it.id}`}>
          <Pencil className="w-3.5 h-3.5" />
        </button>
      )}
      {onDelete && (
        <button onClick={(e) => { e.stopPropagation(); onDelete(it); }} className="opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-red-500 shrink-0" data-testid={`delete-item-${it.id}`}>
          <Trash2 className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};
